module.exports = __webpack_public_path__ + "img/posIcon.44c42d94.png";